<!-- 影院列表-->

<template>
    <div class="root-wrap fx-column">
        <div class="header-wrap">
            <Header type="light"></Header>
            <screen-area @change="initPage"></screen-area>
        </div>
        <div class="body-wrap fx-fill">
            <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="0">
                <cinema-table :list="cinemaList" @click="goCinema"></cinema-table>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '@/components/header';
import ScreenArea from '@/components/cinema/screen-area';
import CinemaTable from '@/components/cinema/cinema-table';
import { mapGetters } from 'vuex';
import { getAMapLocation, movie_get_user_location } from '@/libs/map-utils.js';

export default {
    data() {
        return {
            movieId: this.$route.query.movieId,
            movieName: this.$route.query.movieName,
            cinemaList: [],
            pagination: this.$config.getDefaultPagination(),
        }
    },

    methods: {
        goCinema(cinemaId) {
            this.$goPage('movie-session', {
                cinemaId,
                movieId: this.movieId,
            });
        },

        loadMore() {
            budo_log.debug("#42 getCinemaList, loadMore", this.pagination)

            if (this.pagination.next) {
                ++this.pagination.current_page;
                this.getCinemaList();
            }
        },

        getAMapLocation() {
            getAMapLocation().then((res) => {
                this.$store.commit('setLocation', res);
            })
        },

        getCinemaList() {
            let params = {
                citycode: this.currentCityCode,
                countycode: this.currentCountyCode,
                countyName: this.currentCountyName,
                longitude: this.position ? this.position.lng : 104.05338287353516,
                latitude: this.position ? this.position.lat : 30.537567138671875,
                vcType: 'wp',
                page_no: this.pagination.current_page
            }

            this.movieId ? params.movieid = this.movieId : '';
            this.$service.get_cinema_list(params).then((res) => {
                this.cinemaList = this.cinemaList.concat(res.data.cinemaList);
                this.pagination = res.data.pagination;
            })
        },

        initPage() {
            this.pagination = this.$config.getDefaultPagination();
            this.cinemaList = [];
            this.getCinemaList();
            if (this.movieName) {
                this.$store.commit('setTitle', this.movieName)
            }
        }
    },

    mounted() {
        this.$store.commit('setSelectedCounty', null);
        this.initPage();

        movie_get_user_location(location.href).then((change) => {
            if (change) {
                this.initPage()
            }
        });
    },

    computed: {
        ...mapGetters([
            'currentCityCode',
            'position',
            'currentCountyCode',
            'currentCountyName'
        ])
    },

    components: {
        Header,
        ScreenArea,
        CinemaTable
    }
}
</script>

<style lang="scss" scoped>
.body-wrap {
    position: relative;

    >div {
        position: absolute;
        width: 100%;
        top: 0;
        bottom: 0;
        overflow-y: scroll;
    }
}
</style>
